// extracted by mini-css-extract-plugin
export default {"container":"TextWarning_container__Qcxy7"};